import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkMaskedTextInput from 'react/shared/components/true_link/main/form/masked_text_input/TrueLinkMaskedTextInput';
import NameFields from 'react/shared/components/true_link/main/form/name_field/NameFields';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import LabelTooltipAdornment from 'react/signups/card/common/LabelTooltipAdornment';
import ReferralDropdown from 'react/signups/card/common/ReferralDropdown';

export default function ClientForm({ onChange, setFieldTouched, values }) {
  return (
    <>
      <CardText>
        Since you’re the card administrator, we need some more information about you before we help
        you order cards.
      </CardText>
      <NameFields onChange={onChange} setFieldTouched={setFieldTouched} values={values} />
      <TrueLinkMaskedTextInput
        labelText="Phone number"
        mask="999-999-9999"
        name="mobile"
        onChange={onChange}
        placeholder="555-555-5555"
        required
        setFieldTouched={setFieldTouched}
        value={values.mobile}
      />
      <TrueLinkMaskedTextInput
        labelAdornment={<LabelTooltipAdornment />}
        labelText="Your date of birth"
        mask="99/99/9999"
        name="dob"
        onChange={onChange}
        placeholder="MM/DD/YYYY"
        required
        setFieldTouched={setFieldTouched}
        value={values.dob}
      />
      <ReferralDropdown onChange={onChange} setFieldTouched={setFieldTouched} values={values} />
    </>
  );
}

ClientForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    dob: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    mobile: PropTypes.string.isRequired,
    referralCategory: PropTypes.string.isRequired,
    referralCategoryDetail: PropTypes.string.isRequired,
    referralName: PropTypes.string.isRequired,
  }).isRequired,
};
